<!-- Ce composant sert de remplacement direct pour ValidationProvider de vee-validate v3 -->
<!-- Il utilise Field de vee-validate v4 (définit dans le main.ts) mais expose la même API -->
<template>
  <VeeField
    v-slot="slotProps"
    :name="vid || name"
    :rules="rules"
    :validate-on-mount="immediate"
    :validate-on-blur="true"
    :validate-on-change="true"
    :validate-on-input="true"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <slot
      :errors="slotProps.errors"
      :failed-rules="slotProps.failedRules || {}"
      :meta="slotProps.meta"
      :valid="slotProps.meta.valid"
      :validate="slotProps.validate"
      :touched="slotProps.meta.touched"
      :dirty="slotProps.meta.dirty"
      :aria-invalid="slotProps.meta.valid ? 'false' : 'true'"
      :aria-required="slotProps.meta.required ? 'true' : 'false'"
      :aria-errormessage="slotProps.errors && slotProps.errors.length ? slotProps.errors[0] : null"
      :value="slotProps.value"
      :handle-change="slotProps.handleChange"
      :handle-blur="slotProps.handleBlur"
    ></slot>
  </VeeField>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "ValidationProvider",
  props: {
    modelValue: {
      type: [String, Number, Boolean, Array, Object],
      default: undefined,
    },
    rules: {
      type: [Object, String, Array],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "aggressive",
    },
    immediate: {
      type: Boolean,
      default: false,
    },
    bails: {
      type: Boolean,
      default: true,
    },
    skipIfEmpty: {
      type: Boolean,
      default: true,
    },
    tag: {
      type: String,
      default: "span",
    },
    slim: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
})
</script>
